import React from 'react';
import { School } from 'models/school';
import Collections from 'views/School/Collections';
export default function Leagues({ school }: { school: School }) { return <Collections school={school} mode='leagues' />; }
